module.exports = __webpack_public_path__ + "img/search.ba17a452.png";